export default "__VITE_ASSET__ClZPy$57__"